<ui-detail-section
    [highlight]="true"
>
    <ui-detail-tags
        [tags]="[measureGroup.status]"
    />

    @for (measure of measureGroup.measures; track $index; let index = $index) {
        <ui-detail-description
            [class.mt-m]="!!index"
            [htmlDescription]="measure.description"
        />
        <ui-detail-factoid
            [title]="'Kosten'"
            [data]="[measure.cost]"
        />
    }
</ui-detail-section>
